import authBaseHttpRequest from './authBaseHttpRequest';

export const getBranchReportData = ({ pageNumber, pageSize }) => {
  return authBaseHttpRequest({
    method: 'get',
    url: `/dashboard/stats/report/branch/?page=${pageNumber}&page_size=${pageSize}`,
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const getAgencyReportGraphData = ({ startDate, endDate, durationFilter, agency }) => {
  const queryParams = new URLSearchParams({
    start_date: startDate,
    end_date: endDate,
    duration_filter: durationFilter,
  });
  if (agency) {
    queryParams.set('agency', agency);
  }

  return authBaseHttpRequest({
    method: 'get',
    url: `/dashboard/stats/report/agency-report/?${queryParams.toString()}`,
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const getBranchEmployeesData = ({ params }) => {
  return authBaseHttpRequest({
    method: 'post',
    url: `/dashboard/stats/report/employee-list/`,
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const getEmployeeDetails = ({ caregiverId }) => {
  return authBaseHttpRequest({
    method: 'get',
    url: `/dashboard/stats/report/caregiver-data/?caregiverId=${caregiverId}`,
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const getCareCoinTrackerDeta = ({ caregiverId, page, pageSize }) => {
  return authBaseHttpRequest({
    method: 'get',
    url: `/dashboard/stats/report/care-coin-tracker/?caregiverId=${caregiverId}&page=${page}&page_size=${pageSize}`,
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const sendCareCoins = ({ params }) => {
  return authBaseHttpRequest({
    method: 'post',
    url: `/dashboard/add-care-coins/`,
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const fetchEmployeeEarning = (params) => {
  return authBaseHttpRequest({
    method: 'post',
    url: `/dashboard/stats/caregiver-earning/`,
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const retryRedeemReward = ({params}) => {
  return authBaseHttpRequest({
    method: 'post',
    url: `/dashboard/stats/retry-redeem/`,
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const downloadAgencyReport = ({ startDate, endDate, durationFilter = 'MONTHLY', agency }) => {
  const queryParams = new URLSearchParams({
    start_date: startDate,
    end_date: endDate,
    duration_filter: durationFilter,
  });

  if (agency) {
    queryParams.set('agency', agency);
  }

  return authBaseHttpRequest({
    method: 'get',
    url: `/dashboard/stats/report/download-agency-report/?${queryParams.toString()}`,
    responseType: 'blob',
    headers: {
      Accept: '*/*',
    },
  })
    .then((response) => ({ response }))
    .catch((error) => ({ error: error.response || error }));
};

